module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.234b64c0.ttf";